import { FilterViewModel } from '../regulation';

export class RulebookMasterFilter {
    fromDate: string | null;
    toDate: string | null;
    geography: FilterViewModel[];
    country: FilterViewModel[];
    rulebookType: FilterViewModel[];
    regulator: FilterViewModel[];
    keywords: FilterViewModel[];
    owner:string[];
    ruleTopic:string[];

    constructor() {
        this.fromDate = null;
        this.toDate = null;
        this.geography = [];
        this.country = [];
        this.rulebookType = [];
        this.regulator = [];
        this.keywords = [];
        this.owner = [];
        this.ruleTopic = [];
    }
}